import {useContext} from "react";
import {FeedbackContext, FeedbackContextType} from "../context/Feedback.ts";

export const useFeedback = (): FeedbackContextType => useContext(FeedbackContext)
